import { jsxs as $, jsx as t } from "react/jsx-runtime";
import { CartRoutePaths as D, CartEvents as m, CartEventsEnum as w, CartEventsVersionsEnum as y, redeemAndAddToCart as Y } from "@commerce-cart-webcomponents/sdk";
import { ModalWrapper as M } from "@commerce-cart-webcomponents/ui";
import { logObject as L } from "@commerce-product-webcomponents/sdk";
import { useTranslation as T, useNextgenRouter as N, Drawer as j, Button as F, ButtonStyles as I, Theme as c, ButtonSize as q, ButtonWidth as H, AlertMessage as Q, IconStyle as U, IconAlignment as K } from "@nextgen-web-framework/all";
import { Logger as J } from "@nextgen-web-framework/core";
import { useState as u, useEffect as X } from "react";
import "@commerce-cart-webcomponents/ui-composite";
import "@commerce-payment-webcomponents/ui";
import "@commerce-product-webcomponents/ui";
import "@commerce-promotion-webcomponents/ui";
import "./CartDrawer.module-1b10c581.mjs";
import "./InstallmentDetails.module-5852dbff.mjs";
import "@commerce-webcomponents/ui";
import "./SharebarContainer.module-c8284b54.mjs";
import "./components/Molecules/RecommendedProducts/RecommendedProducts.js";
import "./CartCardComponentV2.module-a7cddeaf.mjs";
import "@commerce-subscription-webcomponents/ui-composite";
import "./SubscriptionContainer.module-76258127.mjs";
import Z from "./components/Organisms/APointRedeemProductCard/APointRedeemProductCard.js";
import './assets/ProductSpecs.css';const tt = "#ffffff", ot = "#396e75", et = "#e5fdff", at = "#546223", rt = "#f0fae5", nt = "#a65523", it = "#fff1e8", dt = "#7f3e3e", ct = "#ffe2e2", lt = "#62625a", st = "#f8f8e7", pt = "#38539a", _t = "#707070", mt = "#c8f8d1", ut = "#87c9c8", gt = "#5291b1", ft = "rgba(82, 145, 177, 0.1019607843)", bt = "#445685", zt = "#181d61", Vt = "rgba(24, 29, 97, 0.1019607843)", Ct = "#5969d6", ht = "#ea999d", kt = "#b6577e", $t = "rgba(182, 87, 126, 0.1019607843)", wt = "#7e3e80", yt = "#1e247f", Rt = "rgba(30, 36, 127, 0.1019607843)", Bt = "#da7600", Ot = "#107f47", vt = "#d91734", Gt = "_html_ol6wp_46", a = {
  amwayWhite: tt,
  darkBlue: ot,
  lightBlue: et,
  darkGreen: at,
  lightGreen: rt,
  darkOrange: nt,
  lightOrange: it,
  darkRed: dt,
  lightRed: ct,
  darkYellow: lt,
  lightYellow: st,
  darkPurple: pt,
  darkGrayOnWhite: _t,
  dataVizColor1: mt,
  dataVizColor2: ut,
  dataVizColor3: gt,
  dataVizColor3Background: ft,
  dataVizColor4: bt,
  dataVizColor5: zt,
  dataVizColor5Background: Vt,
  dataVizColor6: Ct,
  dataVizColor7: ht,
  dataVizColor8: kt,
  dataVizColor8Background: $t,
  dataVizColor9: wt,
  dataVizColor10: yt,
  dataVizColor10Background: Rt,
  dataVizAlertOrange: Bt,
  dataVizSuccessGreen: Ot,
  dataVizWarningRed: vt,
  "no-visible": "_no-visible_ol6wp_42",
  html: Gt,
  "apoint-redeem-drawer-container": "_apoint-redeem-drawer-container_ol6wp_80",
  "apoint-redeem-drawer-heading": "_apoint-redeem-drawer-heading_ol6wp_80",
  "apoint-redeem-drawer-body": "_apoint-redeem-drawer-body_ol6wp_88",
  "apoint-redeem-error-msg-text": "_apoint-redeem-error-msg-text_ol6wp_97",
  "apoint-redeem-product-card-container": "_apoint-redeem-product-card-container_ol6wp_100",
  "apoint-redeem-drawer-footer": "_apoint-redeem-drawer-footer_ol6wp_106",
  "skeleton-loading": "_skeleton-loading_ol6wp_1"
};
var R;
const n = (R = J) == null ? void 0 : R.getInstance(L("APointRedeemDrawer")), Me = (B) => {
  var C;
  const { onClose: l, showLink: O, productData: s, productQuantity: v } = B, [G, g] = u(!1), [p, f] = u(""), [x, S] = u(!1), o = T(), b = N(), z = (C = s.productFlags) == null ? void 0 : C.restrictFromPdpDisplay, P = z ? {
    primaryButtonLabel: o("product.composite.aPointRedeemDrawer.apointRedeemSuccessModal.viewCoupon"),
    onPrimarySuccess: () => {
      b.push("/coupons");
    }
  } : {
    primaryButtonLabel: o("product.composite.aPointRedeemDrawer.apointRedeemSuccessModal.proceedToCart"),
    onPrimarySuccess: () => {
      b.push(D.CART);
    }
  }, W = (e) => {
    l && typeof l == "function" && l(e), g(!0);
  }, V = (e) => {
    S(e), g(e);
  };
  X(() => {
    const e = m.subscribeEvents({
      topics: [w.RedeemFailed],
      version: y["1.0.0"],
      cb: (r, { message: i }) => {
        n == null || n.info("cartEvent", r), i && f(i);
      }
    }), d = m.subscribeEvents({
      topics: [w.RedeemSuccessful],
      version: y["1.0.0"],
      cb: (r) => {
        n == null || n.info("cartEvent", r), f(""), V(!0);
      }
    });
    return () => {
      m.unsubscribe([e, d]);
    };
  }, []);
  const A = () => {
    var i;
    const { productId: e, bundle: d } = s;
    let r;
    d && (r = (i = d.slots) == null ? void 0 : i.map((_) => {
      var h, k;
      return {
        id: (h = _.id) == null ? void 0 : h.toString(),
        entries: (k = _.products) == null ? void 0 : k.map((E) => ({
          product: {
            id: E.items[0].itemNumber
          },
          quantity: _.minQty
        }))
      };
    })), Y(e, v ?? 1, z, r);
  };
  return /* @__PURE__ */ $("div", { className: a["apoint-redeem-drawer-container"], children: [
    !G && /* @__PURE__ */ t(
      j,
      {
        header: /* @__PURE__ */ t("h5", { className: a["apoint-redeem-drawer-heading"], children: o("product.composite.aPointRedeemDrawer.heading") }),
        closeOnBackdropClick: !0,
        closeIcon: !0,
        onClose: W,
        bottomGap: 0,
        footer: /* @__PURE__ */ t("div", { className: a["apoint-redeem-drawer-footer"], children: /* @__PURE__ */ t(
          F,
          {
            id: "confirm-redeem-apoint",
            title: o("product.composite.aPointRedeemDrawer.confirmToRedeem"),
            buttonStyle: I.SOLID,
            theme: c.BLACK,
            size: q.SMALL,
            buttonWidth: H.FULL_WIDTH,
            tabIndex: 0,
            disabled: !!p,
            "data-testid": "confirm-redeem-apoint-btn",
            "data-pod-name": "product",
            onClick: A
          }
        ) }),
        children: /* @__PURE__ */ $("div", { className: a["apoint-redeem-drawer-body"], "data-testid": "apoint-redeem-drawer-body-testid", "data-pod-name": "product", children: [
          p && /* @__PURE__ */ t("div", { className: a["apoint-redeem-error-msg-text"], children: /* @__PURE__ */ t(
            Q,
            {
              theme: c.ERROR,
              hasIcon: !0,
              icon: "square-exclamation",
              iconColor: c.ERROR,
              iconStyle: U.REGULAR,
              iconAlignment: K.CENTER,
              textColor: c.ERROR,
              children: o(p)
            }
          ) }),
          /* @__PURE__ */ t("div", { className: a["apoint-redeem-instruction-text"], children: o("product.composite.aPointRedeemDrawer.instructionText") }),
          /* @__PURE__ */ t("div", { className: a["apoint-redeem-product-card-container"], children: /* @__PURE__ */ t(Z, { showLink: O, productData: s }) })
        ] })
      }
    ),
    x && /* @__PURE__ */ t(
      M,
      {
        headLineText: o("product.composite.aPointRedeemDrawer.apointRedeemSuccessModal.headingText"),
        description: o("product.composite.aPointRedeemDrawer.apointRedeemSuccessModal.descriptionText"),
        onCloseClick: () => V(!1),
        ...P
      }
    )
  ] });
}, xt = "#ffffff", St = "#396e75", Pt = "#e5fdff", Wt = "#546223", At = "#f0fae5", Et = "#a65523", Dt = "#fff1e8", Yt = "#7f3e3e", Mt = "#ffe2e2", Lt = "#62625a", Tt = "#f8f8e7", Nt = "#38539a", jt = "#707070", Ft = "#c8f8d1", It = "#87c9c8", qt = "#5291b1", Ht = "rgba(82, 145, 177, 0.1019607843)", Qt = "#445685", Ut = "#181d61", Kt = "rgba(24, 29, 97, 0.1019607843)", Jt = "#5969d6", Xt = "#ea999d", Zt = "#b6577e", to = "rgba(182, 87, 126, 0.1019607843)", oo = "#7e3e80", eo = "#1e247f", ao = "rgba(30, 36, 127, 0.1019607843)", ro = "#da7600", no = "#107f47", io = "#d91734", co = "_html_mmerh_46", Le = {
  amwayWhite: xt,
  darkBlue: St,
  lightBlue: Pt,
  darkGreen: Wt,
  lightGreen: At,
  darkOrange: Et,
  lightOrange: Dt,
  darkRed: Yt,
  lightRed: Mt,
  darkYellow: Lt,
  lightYellow: Tt,
  darkPurple: Nt,
  darkGrayOnWhite: jt,
  dataVizColor1: Ft,
  dataVizColor2: It,
  dataVizColor3: qt,
  dataVizColor3Background: Ht,
  dataVizColor4: Qt,
  dataVizColor5: Ut,
  dataVizColor5Background: Kt,
  dataVizColor6: Jt,
  dataVizColor7: Xt,
  dataVizColor8: Zt,
  dataVizColor8Background: to,
  dataVizColor9: oo,
  dataVizColor10: eo,
  dataVizColor10Background: ao,
  dataVizAlertOrange: ro,
  dataVizSuccessGreen: no,
  dataVizWarningRed: io,
  "no-visible": "_no-visible_mmerh_42",
  html: co,
  "apoint-redeem-info-drawer-container": "_apoint-redeem-info-drawer-container_mmerh_80",
  "apoint-redeem-info-drawer-heading": "_apoint-redeem-info-drawer-heading_mmerh_80",
  "apoint-redeem-info-drawer-body": "_apoint-redeem-info-drawer-body_mmerh_88",
  "apoint-redeem-info-drawer-product-card-container": "_apoint-redeem-info-drawer-product-card-container_mmerh_92",
  "info-container": "_info-container_mmerh_96",
  "info-title-container": "_info-title-container_mmerh_96",
  "info-title": "_info-title_mmerh_96",
  "info-content": "_info-content_mmerh_110",
  "info-instruction-text": "_info-instruction-text_mmerh_117",
  "info-details": "_info-details_mmerh_121",
  "apoint-redeem-info-drawer-footer": "_apoint-redeem-info-drawer-footer_mmerh_124",
  "skeleton-loading": "_skeleton-loading_mmerh_1"
}, lo = "#ffffff", so = "#396e75", po = "#e5fdff", _o = "#546223", mo = "#f0fae5", uo = "#a65523", go = "#fff1e8", fo = "#7f3e3e", bo = "#ffe2e2", zo = "#62625a", Vo = "#f8f8e7", Co = "#38539a", ho = "#707070", ko = "#c8f8d1", $o = "#87c9c8", wo = "#5291b1", yo = "rgba(82, 145, 177, 0.1019607843)", Ro = "#445685", Bo = "#181d61", Oo = "rgba(24, 29, 97, 0.1019607843)", vo = "#5969d6", Go = "#ea999d", xo = "#b6577e", So = "rgba(182, 87, 126, 0.1019607843)", Po = "#7e3e80", Wo = "#1e247f", Ao = "rgba(30, 36, 127, 0.1019607843)", Eo = "#da7600", Do = "#107f47", Yo = "#d91734", Mo = "_html_p485b_46", Te = {
  amwayWhite: lo,
  darkBlue: so,
  lightBlue: po,
  darkGreen: _o,
  lightGreen: mo,
  darkOrange: uo,
  lightOrange: go,
  darkRed: fo,
  lightRed: bo,
  darkYellow: zo,
  lightYellow: Vo,
  darkPurple: Co,
  darkGrayOnWhite: ho,
  dataVizColor1: ko,
  dataVizColor2: $o,
  dataVizColor3: wo,
  dataVizColor3Background: yo,
  dataVizColor4: Ro,
  dataVizColor5: Bo,
  dataVizColor5Background: Oo,
  dataVizColor6: vo,
  dataVizColor7: Go,
  dataVizColor8: xo,
  dataVizColor8Background: So,
  dataVizColor9: Po,
  dataVizColor10: Wo,
  dataVizColor10Background: Ao,
  dataVizAlertOrange: Eo,
  dataVizSuccessGreen: Do,
  dataVizWarningRed: Yo,
  "no-visible": "_no-visible_p485b_42",
  html: Mo,
  "tag-container": "_tag-container_p485b_80",
  "promotion-tag": "_promotion-tag_p485b_86",
  "product-card-entry": "_product-card-entry_p485b_97",
  "promotion-tag-container": "_promotion-tag-container_p485b_97",
  "product-card-entry-heart-icon": "_product-card-entry-heart-icon_p485b_107",
  "cart-product-info": "_cart-product-info_p485b_112",
  "cart-product-checkbox-container": "_cart-product-checkbox-container_p485b_123",
  "card-image": "_card-image_p485b_132",
  "image-link": "_image-link_p485b_139",
  "card-details": "_card-details_p485b_145",
  "cancel-container": "_cancel-container_p485b_150",
  "wishlist-container": "_wishlist-container_p485b_165",
  "card-description": "_card-description_p485b_174",
  "left-panel-installments": "_left-panel-installments_p485b_182",
  "right-panel-installments": "_right-panel-installments_p485b_186",
  "left-panel": "_left-panel_p485b_182",
  "order-details": "_order-details_p485b_226",
  "right-panel": "_right-panel_p485b_186",
  "stock-status-top": "_stock-status-top_p485b_233",
  "stock-status-date-subtext": "_stock-status-date-subtext_p485b_238",
  "stock-status-subtext": "_stock-status-subtext_p485b_239",
  "cpw-variant-cart-container": "_cpw-variant-cart-container_p485b_246",
  "cart-variant-btn": "_cart-variant-btn_p485b_252",
  "button-status-container": "_button-status-container_p485b_255",
  "justify-flex-end": "_justify-flex-end_p485b_264",
  "justify-flex-end-no-margin": "_justify-flex-end-no-margin_p485b_268",
  "remove-wishlist-container": "_remove-wishlist-container_p485b_271",
  "add-to-cart-btn": "_add-to-cart-btn_p485b_278",
  "remove-margin": "_remove-margin_p485b_284",
  "stock-status-toggle": "_stock-status-toggle_p485b_287",
  "quantity-label-padding": "_quantity-label-padding_p485b_292",
  "delete-container": "_delete-container_p485b_295",
  "cart-disposition-status": "_cart-disposition-status_p485b_303",
  "cart-inventory-status": "_cart-inventory-status_p485b_306",
  "product-card-entry-mobile": "_product-card-entry-mobile_p485b_313",
  "adjust-style": "_adjust-style_p485b_331",
  "full-width": "_full-width_p485b_341",
  "display-flex-style": "_display-flex-style_p485b_395",
  "display-flex-row": "_display-flex-row_p485b_401",
  "remove-label-container": "_remove-label-container_p485b_437",
  "skeleton-loading": "_skeleton-loading_p485b_1"
}, Lo = "#ffffff", To = "#396e75", No = "#e5fdff", jo = "#546223", Fo = "#f0fae5", Io = "#a65523", qo = "#fff1e8", Ho = "#7f3e3e", Qo = "#ffe2e2", Uo = "#62625a", Ko = "#f8f8e7", Jo = "#38539a", Xo = "#707070", Zo = "#c8f8d1", te = "#87c9c8", oe = "#5291b1", ee = "rgba(82, 145, 177, 0.1019607843)", ae = "#445685", re = "#181d61", ne = "rgba(24, 29, 97, 0.1019607843)", ie = "#5969d6", de = "#ea999d", ce = "#b6577e", le = "rgba(182, 87, 126, 0.1019607843)", se = "#7e3e80", pe = "#1e247f", _e = "rgba(30, 36, 127, 0.1019607843)", me = "#da7600", ue = "#107f47", ge = "#d91734", fe = "_html_1n66b_46", Ne = {
  amwayWhite: Lo,
  darkBlue: To,
  lightBlue: No,
  darkGreen: jo,
  lightGreen: Fo,
  darkOrange: Io,
  lightOrange: qo,
  darkRed: Ho,
  lightRed: Qo,
  darkYellow: Uo,
  lightYellow: Ko,
  darkPurple: Jo,
  darkGrayOnWhite: Xo,
  dataVizColor1: Zo,
  dataVizColor2: te,
  dataVizColor3: oe,
  dataVizColor3Background: ee,
  dataVizColor4: ae,
  dataVizColor5: re,
  dataVizColor5Background: ne,
  dataVizColor6: ie,
  dataVizColor7: de,
  dataVizColor8: ce,
  dataVizColor8Background: le,
  dataVizColor9: se,
  dataVizColor10: pe,
  dataVizColor10Background: _e,
  dataVizAlertOrange: me,
  dataVizSuccessGreen: ue,
  dataVizWarningRed: ge,
  "no-visible": "_no-visible_1n66b_42",
  html: fe,
  "cpw-product-specs": "_cpw-product-specs_1n66b_80",
  "product-price": "_product-price_1n66b_87",
  "product-specs-middle-section": "_product-specs-middle-section_1n66b_90",
  "product-specs-installment-section": "_product-specs-installment-section_1n66b_93",
  "product-promotion-details": "_product-promotion-details_1n66b_96",
  "wishlist-sharebar-row": "_wishlist-sharebar-row_1n66b_99",
  "product-spec-middle-section": "_product-spec-middle-section_1n66b_113",
  "product-spec-bottom-section": "_product-spec-bottom-section_1n66b_116",
  "skeleton-loading": "_skeleton-loading_1n66b_1"
};
export {
  Me as A,
  Le as a,
  Ne as b,
  Te as s
};
//# sourceMappingURL=ProductSpecs.module-d44c6e54.mjs.map
